import validate from "/builds/monthly-cloud/flat/web/node_modules/nuxt/dist/pages/runtime/validate.js";
import auth_45global from "/builds/monthly-cloud/flat/web/middleware/auth.global.js";
import offline_45global from "/builds/monthly-cloud/flat/web/middleware/offline.global.js";
import set_45website_45configuration_45global from "/builds/monthly-cloud/flat/web/middleware/setWebsiteConfiguration.global.js";
import manifest_45route_45rule from "/builds/monthly-cloud/flat/web/node_modules/nuxt/dist/app/middleware/route-rules.js";
export const globalMiddleware = [
  validate,
  auth_45global,
  offline_45global,
  set_45website_45configuration_45global,
  manifest_45route_45rule
]
export const namedMiddleware = {}